import { render, staticRenderFns } from "./Denuncias.vue?vue&type=template&id=6bfb0573&"
import script from "./Denuncias.vue?vue&type=script&lang=js&"
export * from "./Denuncias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports